import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

class AdminHallTicket extends Component {

  constructor(props) {
    super(props);
    this.state ={

    }
    this.handleRendering = this.handleRendering.bind(this);
    this.handleHallTicketDetails =  this.handleHallTicketDetails.bind(this);
  }

  componentDidMount() {

  }

  handleRendering(urlInput, type, uploadType) {
    if(urlInput !== 'view')
      this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${uploadType}`)
    else{
      let typeId = 3
      this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${typeId}/${uploadType}`)
    }
  }

  handleHallTicketDetails() {
    this.props.history.push(`/portal/app/admin/hallticket/details`)
  }

  render() {
    return(
      <div>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <GridCell span="12">
                <Typography use="headline6">Hall Ticket Excel Upload</Typography>
              </GridCell>
              <GridCell span="12">
                <GridCell span="6">
                  <Typography use="headline6" onClick={() => this.handleRendering("upload","new", "hallticket")} style={{color: 'blue',textDecorationLine: 'underline'}}> Import New </Typography>
                </GridCell>
                <GridCell span="6">
                  <Typography use="headline6" onClick={() => this.handleRendering("upload","update", "hallticket")} style={{color: 'blue',textDecorationLine: 'underline'}}>Update Existing</Typography>
                </GridCell>
              </GridCell>
              <GridCell span="12">
                <Typography use="headline6" onClick={() => this.handleRendering("view","history", "hallticket")} style={{color: 'blue',textDecorationLine: 'underline'}}> View uploaded excel history</Typography>
              </GridCell>
            </Card>
            <br/>
            <Card style={{padding: '25px'}}>
              <GridCell span="12">
                <Typography use="headline6">View </Typography>
              </GridCell>
              <GridCell span="12">
                <Typography use="headline6" onClick={this.handleHallTicketDetails} style={{color: 'blue',textDecorationLine: 'underline'}}> View Hall Ticket details</Typography>
              </GridCell>
            </Card>
          </GridCell>
        </Grid>
      </div>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicket);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicket.jsx